import { PasseriniAPI } from '@/services/apiService';
import {
  Cobros,
  TipoMoneda,
  IniciarCobroData,
  EditarMontoCobroData,
  CobroFormData,
  Cobro,
} from '../types/cobros';

export const cobrosService = {
  /**
   * Obtener cobros de un otro trámite
   */
  getCobros: async (otroTramiteId: string): Promise<Cobros> => {
    const response = await PasseriniAPI.get(`/otros-tramites/${otroTramiteId}/cobros`);
    return response.data;
  },

  /**
   * Iniciar cobros en una moneda específica
   */
  iniciarCobro: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    data: IniciarCobroData
  ): Promise<Cobros> => {
    const response = await PasseriniAPI.post(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/iniciar`,
      data
    );
    return response.data;
  },

  /**
   * Registrar un cobro
   */
  registrarCobro: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    data: CobroFormData
  ): Promise<Cobro> => {
    const response = await PasseriniAPI.post(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/cobros`,
      data
    );
    return response.data;
  },

  /**
   * Registrar cobro total (automático)
   */
  registrarCobroTotal: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    cajaId?: number | null
  ): Promise<Cobro> => {
    const response = await PasseriniAPI.post(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/cobros/total`,
      { cajaId: cajaId ?? null }
    );
    return response.data;
  },

  /**
   * Actualizar un cobro existente
   */
  actualizarCobro: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    cobroId: string,
    data: CobroFormData
  ): Promise<Cobro> => {
    const response = await PasseriniAPI.put(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/cobros/${cobroId}`,
      data
    );
    return response.data;
  },

  /**
   * Eliminar un cobro
   */
  eliminarCobro: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    cobroId: string
  ): Promise<void> => {
    await PasseriniAPI.delete(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/cobros/${cobroId}`
    );
  },

  /**
   * Editar monto del cobro
   */
  editarMontoCobro: async (
    otroTramiteId: string,
    moneda: TipoMoneda,
    data: EditarMontoCobroData
  ): Promise<Cobros> => {
    const response = await PasseriniAPI.put(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}/monto`,
      data
    );
    return response.data;
  },

  /**
   * Eliminar (resetear) cobro
   */
  eliminarCobros: async (
    otroTramiteId: string,
    moneda: TipoMoneda
  ): Promise<Cobros> => {
    const response = await PasseriniAPI.delete(
      `/otros-tramites/${otroTramiteId}/cobros/${moneda.toLowerCase()}`
    );
    return response.data;
  },
};
